import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "quiz-draggable-area-item__handle",
  role: "button"
}
const _hoisted_2 = {
  key: 2,
  class: "tracking-indicator"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "daily-sync-task__attributes" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "goal-name" }, "Clear goal", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "goal-name" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" No active goals available. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Create a new goal")
const _hoisted_15 = {
  key: 0,
  class: "daily-sync-assignee-dropdown__dropdown"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "menu-header" }, "SET STATUS", -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "menu-header" }, "ACTION", -1)
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_DailySyncTaskEditor = _resolveComponent("DailySyncTaskEditor")!
  const _component_AppBasicDropdown = _resolveComponent("AppBasicDropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppAvatar = _resolveComponent("AppAvatar")!
  const _component_AppTimeTracker = _resolveComponent("AppTimeTracker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["daily-sync-task", { 'daily-sync-task__completed': _ctx.dailySyncTask.completed, 'daily-sync-task__readonly': !_ctx.editable, 'daily-sync-task__tracking': _ctx.isTrackingCurrentTask }])
  }, [
    ((_ctx.isBacklog || _ctx.isGoalBacklog) && !_ctx.isTaskEmpty())
      ? _withDirectives((_openBlock(), _createBlock(_component_AppIcon, {
          key: 0,
          class: "focus-list",
          name: "arrow-slim",
          size: "16",
          onClick: _ctx.sendToTaskList
        }, null, 8, ["onClick"])), [
          [_directive_tooltip, { distance: '12', content: 'Send to focus list' }]
        ])
      : _createCommentVNode("", true),
    (_ctx.editable && !_ctx.isTaskEmpty())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_AppIcon, { name: "drag-vertical-handle" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasOpenTimeblock && !_ctx.editable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_AppCheckbox, {
      modelValue: _ctx.dailySyncTask.completed,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dailySyncTask.completed) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change')))
      ],
      disabled: !_ctx.editable,
      theme: "task-status",
      variant: "small"
    }, null, 8, ["modelValue", "disabled"]), [
      [_vShow, (!_ctx.isTaskEmpty() && !_ctx.isGoal && !_ctx.isBacklog && !_ctx.isGoalBacklog && _ctx.editable) || (!_ctx.hasOpenTimeblock && !_ctx.editable)]
    ]),
    _createVNode(_component_DailySyncTaskEditor, {
      ref: "editorRef",
      modelValue: _ctx.dailySyncTask.text,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dailySyncTask.text) = $event)),
        _ctx.onTextUpdated
      ],
      hasFocus: _ctx.hasFocus,
      class: _normalizeClass({ 'dre-task': _ctx.dailySyncTask.category === 'Dre' }),
      editable: _ctx.editable && _ctx.dailySyncTask.category !== 'Dre' && !_ctx.isTrackingCurrentTask,
      onSubmit: _ctx.submitTask,
      onDelete: _ctx.deleteTask,
      onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('focus'))),
      onBlur: _ctx.saveChangesToText
    }, null, 8, ["modelValue", "hasFocus", "class", "editable", "onSubmit", "onDelete", "onBlur", "onUpdate:modelValue"]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(`category-badge ${_ctx.dailySyncTask.category}`)
      }, _toDisplayString(_ctx.dailySyncTask.category), 3), [
        [_vShow, !_ctx.isTaskEmpty()]
      ]),
      (_ctx.showGoal)
        ? _withDirectives((_openBlock(), _createBlock(_component_AppDropdown, {
            key: 0,
            class: "daily-sync-task__goal-dropdown"
          }, _createSlots({
            handler: _withCtx((props) => [
              (_ctx.goal)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: props.visibility.toggle,
                    class: _normalizeClass(["daily-sync-task__goal", { 'daily-sync-task__goal__disabled': !_ctx.editable }]),
                    style: _normalizeStyle(`color: var(--color-${_ctx.goal.goalColor}); background-color: rgba(var(--color-${_ctx.goal.goalColor}-rgb),.05); border-color: var(--color-${_ctx.goal.goalColor});`)
                  }, _toDisplayString(_ctx.goal.goalRef), 15, _hoisted_6))
                : (_ctx.editable)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: props.visibility.toggle,
                      class: "daily-sync-task__goal",
                      style: _normalizeStyle(`color: var(--color-azure); background-color: rgba(var(--color-basalt-rgb),.05); border-color: var(--color-basalt);`)
                    }, " GOAL ", 12, _hoisted_7))
                  : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (_ctx.editable)
              ? {
                  name: "default",
                  fn: _withCtx((props) => [
                    (_ctx.filteredGoals.length)
                      ? (_openBlock(), _createBlock(_component_AppBasicDropdown, { key: 0 }, {
                          items: _withCtx(() => [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (props.visibility.toggle(), _ctx.clearGoal()),
                              class: "menu-item"
                            }, _hoisted_10, 8, _hoisted_8),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGoals, (goal) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: goal.id,
                                onClick: ($event: any) => (props.visibility.toggle(), _ctx.setGoal(goal)),
                                class: "menu-item"
                              }, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(goal.title), 1),
                                _createElementVNode("span", {
                                  class: "goal-tag",
                                  style: _normalizeStyle(`color: var(--color-${goal.goalColor}); background-color: rgba(var(--color-${goal.goalColor}-rgb),.05);`)
                                }, _toDisplayString(goal.goalRef), 5)
                              ], 8, _hoisted_11))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_AppBasicDropdown, { key: 1 }, {
                          items: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _hoisted_13,
                              _createVNode(_component_router_link, { to: "/goals" }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }))
                  ])
                }
              : undefined
          ]), 1536)), [
            [_vShow, !_ctx.isTaskEmpty()]
          ])
        : _createCommentVNode("", true),
      (_ctx.showAssignee && !_ctx.isTaskEmpty())
        ? (_openBlock(), _createBlock(_component_AppDropdown, {
            key: 1,
            type: "simple"
          }, {
            handler: _withCtx((props) => [
              (_openBlock(), _createBlock(_component_AppAvatar, {
                size: "tiny",
                user: _ctx.assignedUser,
                showIfEmpty: true,
                onClick: props.visibility.toggle,
                key: _ctx.assignedUser
              }, null, 8, ["user", "onClick"]))
            ]),
            default: _withCtx((props) => [
              (!_ctx.isGoalBacklog)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_AppBasicDropdown, {
                      onClick: props.visibility.toggle
                    }, {
                      items: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (user, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "daily-sync-assignee-dropdown__user",
                            key: index,
                            onClick: ($event: any) => (_ctx.updateAssignee(user?.userId))
                          }, [
                            _createVNode(_component_AppAvatar, {
                              user: user.userProfile,
                              size: "smaller",
                              showIfEmpty: true
                            }, null, 8, ["user"]),
                            (user.userProfile)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(user.userProfile.firstName) + " " + _toDisplayString(user.userProfile.lastName), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_18, "Unassigned"))
                          ], 8, _hoisted_16))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.editable && !_ctx.isTaskEmpty() && !_ctx.isBacklog && !_ctx.isGoal && !_ctx.isGoalBacklog && !_ctx.dailySyncTask.completed && _ctx.paidOrTrialSubscription)
        ? (_openBlock(), _createBlock(_component_AppTimeTracker, {
            key: 2,
            task: _ctx.task,
            "onTimetracker:update": _ctx.updateTaskTime,
            "onTimetracker:override": _ctx.overrideTaskTime
          }, null, 8, ["task", "onTimetracker:update", "onTimetracker:override"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.editable)
      ? _withDirectives((_openBlock(), _createBlock(_component_AppDropdown, {
          key: 3,
          class: "daily-sync-task__expand-dropdown"
        }, {
          handler: _withCtx((props) => [
            _createElementVNode("button", {
              onClick: props.visibility.toggle,
              class: "floating-toggle"
            }, [
              _createVNode(_component_AppIcon, {
                name: "expand",
                size: "18"
              })
            ], 8, _hoisted_19)
          ]),
          default: _withCtx((props) => [
            _createVNode(_component_AppBasicDropdown, null, {
              items: _withCtx(() => [
                (_ctx.dailySyncTask.category !== 'Dre')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_20,
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.updateTaskCategory('Task'), props.visibility.toggle()),
                        class: _normalizeClass(["menu-item Task", { 'selected': _ctx.dailySyncTask.category === 'Task' }])
                      }, "Task", 10, _hoisted_21),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.updateTaskCategory('Blocked'), props.visibility.toggle()),
                        class: _normalizeClass(["menu-item Blocked", { 'selected': _ctx.dailySyncTask.category === 'Blocked' }])
                      }, "Blocked", 10, _hoisted_22),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.updateTaskCategory('Feedback'), props.visibility.toggle()),
                        class: _normalizeClass(["menu-item Feedback", { 'selected': _ctx.dailySyncTask.category === 'Feedback' }])
                      }, "Feedback", 10, _hoisted_23),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.updateTaskCategory('Discuss'), props.visibility.toggle()),
                        class: _normalizeClass(["menu-item Discuss", { 'selected': _ctx.dailySyncTask.category === 'Discuss' }])
                      }, "Discuss", 10, _hoisted_24)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_25,
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.dailySyncTask.completed = !_ctx.dailySyncTask.completed, props.visibility.toggle(), _ctx.$emit('change')),
                  class: "menu-item Complete"
                }, "Complete", 8, _hoisted_26),
                (_ctx.dailySyncTask.goalId && !_ctx.isInFocus && !_ctx.isGoal && !_ctx.isGoalBacklog)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteTask(true))),
                      class: "menu-item Delete"
                    }, "Unassign"))
                  : _createCommentVNode("", true),
                (!_ctx.dailySyncTask.goalId && _ctx.isInFocus || _ctx.dailySyncTask.goalId && _ctx.isGoal)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteTask(true))),
                      class: "menu-item Delete"
                    }, "Delete"))
                  : _createCommentVNode("", true),
                (!_ctx.isBacklog && !_ctx.isGoal && !_ctx.isGoalBacklog)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendToBacklog(true))),
                      class: "menu-item Task"
                    }, " Backlog"))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 512)), [
          [_vShow, !_ctx.isTaskEmpty()]
        ])
      : _createCommentVNode("", true)
  ], 2))
}